export class Country {
    constructor(
        public locale: string,
        public name: string
    ) {
    }
}
